import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import CustomTextInput from '@/components/CustomTextInput'
import CustomButton from '@/components/CustomButton'
import { Toast } from 'react-vant'
import { useSendCode } from '@/hooks/useSendCode'

export default React.memo(function BindEmail() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [email, setEmail] = useState('')
    const { sendCode, sendCodeLoading } = useSendCode()

    // 验证邮箱格式
    const isValidEmail = (email: string) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return emailRegex.test(email)
    }

    // 发送验证码
    const handleSendCode = async () => {
        if (!email.trim()) {
            Toast.fail(t('请输入邮箱'))
            return
        }

        if (!isValidEmail(email)) {
            Toast.fail(t('请输入有效的邮箱地址'))
            return
        }

        try {
            await sendCode({
            account: email,
            scene: 'bind_email',
            callBack: () => {
                // 跳转到验证码验证页面
                navigate('/safety/bind-email/verify-code', {
                    state: { email }
                })
            }
        });
        } catch (error) {
            console.error('发送验证码失败:', error)
        }
    }

    return (
        <PageLayout tabbarPage={false}>
            <Header
                leftChildren={<Back />}
                centerChildren={<div className="text-3.75 font-medium text-black">{t('绑定邮箱')}</div>}
            />
            <div className='px-6 py-6'>
                {/* 邮箱输入 */}
                <div className="mb-6">
                    <div className="text-3.5 text-[#1A1A1A] mb-3">{t('邮箱')}</div>
                    <CustomTextInput
                        value={email}
                        onChangeText={setEmail}
                        placeholder={t('请输入邮箱')}
                        inputMode='email'
                    />
                </div>

                {/* 发送验证码按钮 */}
                <CustomButton
                    onClick={handleSendCode}
                    loading={sendCodeLoading}
                    disabled={!email.trim() || sendCodeLoading}
                >
                    {t('发送验证码')}
                </CustomButton>
            </div>
        </PageLayout>
    )
})